import { getApiClient } from './apiService'
import config from '../config/env'

const getCategories = async () => {
  try {
    const response = await getApiClient().get('/categories')
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getCategories error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const addCategory = async data => {
  try {
    const response = await getApiClient().post('/categories', data)
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('addCategory error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const categoryService = {
  getCategories,
  addCategory,
}
